import { render, staticRenderFns } from "./MortgageSummaryHelp.vue?vue&type=template&id=004c71c3&scoped=true"
import script from "./MortgageSummaryHelp.vue?vue&type=script&lang=js"
export * from "./MortgageSummaryHelp.vue?vue&type=script&lang=js"
import style0 from "./MortgageSummaryHelp.vue?vue&type=style&index=0&id=004c71c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004c71c3",
  null
  
)

export default component.exports